import {
  AdditionalMultimediaInfo,
  MultimediaMessageContent,
  MultimediaInfo
} from '@/types/matrix';
import {MatrixClient, MsgType} from 'matrix-js-sdk';

export const sendVideos = async (
  matrixClient: MatrixClient,
  currentMatrixRoomId: string,
  videos: File[],
  text: string
): Promise<string> => {
  try {
    let firstVideoContent: MultimediaMessageContent | undefined;
    const additionalImageInfos: AdditionalMultimediaInfo[] = [];
    let sentEventId = '';

    for (let index = 0; index < videos.length; index++) {
      const file = videos[index];
      const uploadResponse = await matrixClient.uploadContent(file);
      const videoUrl = uploadResponse.content_uri;

      if (typeof videoUrl !== 'string') {
        throw new Error('Cannot fetch image url');
      }

      const videoInfo: MultimediaInfo = {
        w: 100,
        h: 100,
        mimetype: file.type,
        index: index
      };

      if (index === 0) {
        firstVideoContent = {
          url: videoUrl,
          info: videoInfo,
          body: text,
          additional: []
        };
      } else {
        additionalImageInfos.push({url: videoUrl, info: videoInfo});
      }
    }
    if (videos.length > 1 && firstVideoContent) {
      firstVideoContent.additional = additionalImageInfos;
    }

    if (firstVideoContent) {
      const response = await matrixClient.sendMessage(currentMatrixRoomId, {
        msgtype: MsgType.Video,
        body: firstVideoContent.body ?? '',
        ...firstVideoContent
      });
      sentEventId = response.event_id;
    }

    return sentEventId;
  } catch (error) {
    console.error('Error while sending video message: ', error);
    throw error;
  }
};
